import BaseService from './base_service'
class StripeUpdateService extends BaseService {
  constructor (options) {
    super(options)
    this.method = 'POST'
    this.stripeUpdateUrl = options.stripeUpdateUrl
  }

  fromCache () {
    return Promise.resolve(null)
  }

  toCache (_) { }
  get serviceName () {
    return 'stripe_update'
  }

  get fetchHeaders () {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  }

  get apiUrl () {
    return this.baseApiUrl
  }

  get baseApiUrl () {
    return new URL(this.stripeUpdateUrl)
  }
}
export default StripeUpdateService
